import {useMutation} from '@tanstack/react-query'
import {useGetConfigApiMethod} from 'api/useGetConfigApiMethod'

export const useGetConfigMutation = () => {
  const getConfig = useGetConfigApiMethod()

  return useMutation({
    mutationFn: getConfig,
  })
}
